import { InjectionToken, Provider } from '@angular/core';
import { gettext } from './@core';
import { environment } from '@src/environments';

export const SETTINGS_TOKEN = new InjectionToken<Settings>('ngx.settings');
export const APP_NAME_TAG = 'lunchappadmin';
export const DEFAULT_LANG = 'pl';

export interface Settings {
  appName: string;
  defaultLang: string;
  timezone: string;
  baseSmartTableSettings: any;
  defaultPageSize: number;
  queryDebounceTime: number;
  ipMask: string;
  baseHref: string;
  menusTags: {
    pages: string;
    user: string;
  };
}

const SETTINGS: Settings = {
  appName: gettext('app_name'),
  defaultLang: 'pl',
  timezone: 'Europe/Warsaw',
  baseSmartTableSettings: {
    pager: {
      display: true,
      perPage: 50
    }
  },
  defaultPageSize: 50,
  queryDebounceTime: 300,
  ipMask: '[099]{.}[099]{.}[099]{.}[099]',
  baseHref: environment.baseHref,
  menusTags: {
    pages: 'pages-menu',
    user: 'user-menu'
  }
};

export const SETTINGS_PROVIDER: Provider = { provide: SETTINGS_TOKEN, useValue: SETTINGS };
